<template lang="pug">
  .sidebar
    .sidebar__toolbar(v-if="isDesktop")
      h2.sidebar__title {{ activeItem.title | translate }}
    .sidebar__menu-wrapper(v-click-outside="()=>{ minified = true }")
      v-card.sidebar__menu(
        :class="menuClasses"
        :elevated="isMenuCardElevated")
        template(v-if="isMinified")
          farm-sidebar-item(
            togglable
            :item="activeItem"
            @click="toggleMinified")
        template(v-else)
          template(v-for="item in items")
            farm-sidebar-item(
              v-if="showItem(item)"
              :item="item"
              @click="navigate")
    history-menu(
      v-if="activeItem.id === 5"
      :elevated="!isDesktop")
</template>

<script>
import { mapGetters } from 'vuex'

import FarmSidebarItem from './FarmSidebarItem'
import HistoryMenu from './HistoryMenu'

import adaptationMixin from '@/mixins/adaptation.mixin.js'
import { getFarmPath } from '@/util/app.js'

export default {
  name: 'FarmSidebar',

  components: {
    FarmSidebarItem,
    HistoryMenu
  },

  mixins: [adaptationMixin],

  data: () => ({
    items: [
      { id: 0, title: 'sidebar.schedule', path: 'planning', icon: 'icon-schedules', screen: 'desktop tablet mobile', access: 'profeed', need_minified: false },
      { id: 1, title: 'sidebar.animalfeed_schedule', path: 'kkz', icon: 'icon-factory', screen: 'desktop tablet', access: 'animalfeed', need_minified: false },
      { id: 2, title: 'sidebar.animals', path: 'animal-groups', icon: 'icon-animals', screen: 'desktop tablet mobile', access: 'profeed', need_minified: false },
      { id: 3, title: 'sidebar.stock', path: 'stock', icon: 'icon-storage', screen: 'desktop tablet mobile', access: 'profeed', need_minified: false },
      { id: 4, title: 'sidebar.rations', path: 'rations', icon: 'icon-rations', screen: 'desktop tablet mobile', access: 'profeed', need_minified: false },
      { id: 5, title: 'sidebar.history', path: 'history', icon: 'icon-history', screen: 'desktop tablet', access: 'profeed', need_minified: true },
      { id: 6, title: 'sidebar.reports', path: 'reports', icon: 'icon-reports', screen: 'desktop tablet mobile', access: 'all', need_minified: true }
    ],
    minified: true
  }),

  methods: {
    isActive (item) {
      const farmId = this.$route.params.farm_id
      return this.$route.path
        .includes(`${farmId}/${item.path}`)
    },

    toggleMinified () {
      this.minified = !this.minified
    },

    navigate (item) {
      this.minified = true
      const farmId = this.$route.params.farm_id
      let path = getFarmPath(null, this.$route, item.path)

      if (farmId && item.path !== 'planning') {
        path += `?farm=${farmId}`
      }
      this.$router.push(path)
    },

    showItem (item) {
      switch (item.access) {
        case 'profeed':
          return this.hasProfeed || true
        case 'animalfeed':
          return this.hasAnimalfeed
        case 'all':
          return this.hasProfeed ||
          this.hasAnimalfeed || true
        default:
          return false
      }
    }
  },

  computed: {
    ...mapGetters('account', [
      'hasAnimalfeed',
      'hasProfeed'
    ]),

    activeItem () {
      return this.items
        .find(item => this.isActive(item))
    },

    isMinified () {
      return this.activeItem.need_minified &&
        this.minified
    },

    isMenuCardElevated () {
      return !this.isDesktop ||
        (this.activeItem.need_minified && !this.minified)
    },

    menuClasses () {
      return {
        'sidebar__menu--elevated': this.activeItem.need_minified,
        'sidebar__menu--minified': this.isMinified
      }
    }
  }
}
</script>
